































import Vue from 'vue';
import CampusSelectionForm from '@/components/forms/CampusSelectionForm.vue';
import PipelineMenuWrapper from '@/components/PipelineMenuWrapper.vue';
import BackButton from '@/components/BackButton.vue';
import ModalCampus from '@/components/Modal/ModalCampus.vue';
import Modal from '@/components/Modal/Modal.vue';
import pipeline from '@/pipeline';
import { Campus } from '@/store/modules/location/state';
import Analytics from '@/helpers/analytics';
import { Toast } from '@descomplica/vue-components';
import { AnalyticsActions } from '@/store/modules/analytics/actions';

export default Vue.extend({
  components: {
    CampusSelectionForm,
    PipelineMenuWrapper,
    BackButton,
    Modal,
    ModalCampus,
    Toast,
  },
  data() {
    return {
      error: false,
      isModalVisible: false,
    };
  },
  computed: {
    availableCampuses(): Campus[] {
      return this.$store.getters.availableCampuses || [];
    },
    selectedCampus(): string {
      return this.$store.getters.selectedCampus?.id;
    },
    campusDetails(): Campus {
      return this.$store.getters.campusDetails;
    },
  },
  created() {
    this.$store.dispatch('PULL_AVAILABLE_CAMPUSES');
  },
  methods: {
    async selectedHandler(campus: Campus) {
      await this.$store
        .dispatch('UPDATE_CAMPUS', { campus })
        .catch(error => this.errorHandler(error));

      this.$store.dispatch(AnalyticsActions.POLO_CHOSEN, {
        grad_primeira_opcao_polo: campus.name,
        polo: campus.name,
      });
      Analytics.trackGTM({
        event: 'campus_selected',
        grad_selected_campus: campus.name,
        processo_seletivo_id: this.$store.getters.admissionId,
      });

      pipeline.next();
    },
    errorHandler(error: any) {
      this.error = true;
      setTimeout(() => {
        this.error = false;
      }, 5000);
      throw error;
    },
    async infoHandler(campus: Campus) {
      await this.$store.dispatch('PULL_CAMPUS_DETAILS', { campus });
      this.isModalVisible = true;
    },
    closeModalHandler() {
      this.isModalVisible = false;
    },
  },
});
